<template>
  <router-link
    v-tooltip="{ title: tooltip }"
    :to="{ name: routeName, params: params }"
    :class="'action btn btn-' + (className ? className : 'primary')"
  >
    {{ text ?? "" }} <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon"
  /></router-link>
</template>

<script>
export default {
  name: "RouterLinkComponent",
  props: {
    icon: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      required: true,
    },
    params: {
      type: {},
      required: false,
      default: () => {},
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>
